import { createRemoteReducer, RemoteReducer } from "types/Remote"
import { PKDOption } from "types/Template"

export const pkdReducer: RemoteReducer<PKDOption[]> = createRemoteReducer("pkd")
